import HttpClient from '@/common/boot/HttpClient'

////////////////////////////////////////////////////
// const deletarUsuario = async ({ commit }, payload) => {
//   commit('BUSCANDO', true);

//   return await HttpClient.delete(`/app/users/${payload.id}`).then(response => {
//     commit('DELETAR_USUARIO', payload)
//     return response;
//   })
//   .finally( () => {
//     commit('BUSCANDO', false);
//   })

// }

const listarPerfis = async ({commit}) => {
  commit('BUSCANDO', true);

  return await HttpClient.get(`/roles`).then(response => {
    commit('INSERIR_LISTA_PERFIS', response.data.data)
    return response;
  })
  .finally( () => {
    commit('BUSCANDO', false);
  })
}

const recuperarUsuarioComPerfis = async ({ commit }, payload) => {
  commit('BUSCANDO', true);

  return await HttpClient.get(`/usuarios/${payload}`, payload).then(response => {
    commit('INSERIR_USUARIO_SELECIONADO', response.data.data)
    return response;
  })
  .finally( () => {
    commit('BUSCANDO', false);
  });
}

const associarPerfisAoUsuario = ({ commit }, payload) => {
  commit('BUSCANDO', true);

  HttpClient.post(`/usuarios/${payload.usuarioId}/roles/sincronizar`, payload).then(response => {
    return response;
  })
  .finally( () => {
    commit('BUSCANDO', false);
  });
}

export {
  // deletarUsuario,
  listarPerfis,
  recuperarUsuarioComPerfis,
  associarPerfisAoUsuario
}